/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { User } from '../../models/user';
import { User2 } from '../../models/user-2';

export interface PostApiLogin$Params {
      body?: User & {
'_remember_me'?: boolean;
}
}

export function postApiLogin(http: HttpClient, rootUrl: string, params?: PostApiLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<User2>> {
  const rb = new RequestBuilder(rootUrl, postApiLogin.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<User2>;
    })
  );
}

postApiLogin.PATH = '/api/login';
